module.exports = __webpack_public_path__ + "static/media/gold2.6dde449d.png";